import React, { PropsWithChildren } from 'react'
import { ChannelListMessengerProps } from 'stream-chat-react'
import './MessagingChannelList.css'
import { SkeletonLoader } from './SkeletonLoader'
import { ReactComponent as NoSearchResultIcon } from '../../../../assets/svgs/no-search-result-icon.svg'

interface MessagingChannelListProps extends ChannelListMessengerProps {
  isSearching?: boolean
  hasSearchResults?: boolean
  searchQuery?: string
}

const MessagingChannelList = (props: PropsWithChildren<MessagingChannelListProps>) => {
  const {
    children,
    error = false,
    loading,
    isSearching,
    hasSearchResults = true,
    searchQuery,
  } = props
  const searchActive = Boolean(searchQuery?.trim())
  const showNoResultsPlaceholder =
    searchActive && !loading && !error && !isSearching && hasSearchResults === false

  if (error) {
    return (
      <div className="messaging__channel-list__message">
        Error loading your chats - please try again in a little bit.
      </div>
    )
  }

  if (loading) {
    return (
      <div className="messaging__channel-list__message">
        <SkeletonLoader />
      </div>
    )
  }

  // Check if children is null, undefined, or an empty array (no channels loaded)
  // stream-chat-react passes null children when there are no channels
  if (showNoResultsPlaceholder) {
    return (
      <div className="flex flex-col items-center justify-center py-8 text-center px-6">
        <div className="mb-4">
          <NoSearchResultIcon className="w-[60px] h-[56px] mx-auto" />
        </div>
        <p className="text-app-grey-80 text-base font-semibold mb-1">No conversations found</p>
        <p className="text-app-grey-60 text-base font-normal">
          Try searching with different keywords
        </p>
      </div>
    )
  }

  return (
    <div className={searchActive ? 'messaging__channel-list__search-results' : ''}>{children}</div>
  )
}

export default React.memo(MessagingChannelList)
